<template>
    <tr>
        <td v-if="!isSalesStaff">
            <button v-if="checkIfEditEnabled" class="button is-link" @click="updatePrice()">
                <i class="fas fa-save"></i>
            </button>
            <button  v-if="!checkIfEditEnabled" class="button" @click="editPrice(price)">
                <i class="fas fa-edit"></i>
            </button>
        </td>
        <td>
            #{{ price.id }}
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ price.lot_start }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="lot_start" placeholder="Lot start #"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ price.lot_end }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="lot_end" placeholder="Until lot #"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ price.auction }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="auction" placeholder="Auction Name"/>
        </td>
        <td v-if="!isSalesStaff">
            <span v-if="!checkIfEditEnabled">{{ price.yokohama }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="yokohama" placeholder="Delivery to Yokohama"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ price.yokohama_sales }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="yokohama_sales" placeholder="Delivery to Yokohama"/>
        </td>
        <td v-if="!isSalesStaff">
            <span v-if="!checkIfEditEnabled">{{ price.nagoya }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="nagoya" placeholder="Delivery to Nagoya"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ price.nagoya_sales }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="nagoya_sales" placeholder="Delivery to Nagoya"/>
        </td>
        <td v-if="!isSalesStaff">
            <span v-if="!checkIfEditEnabled">{{ price.osaka }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="osaka" placeholder="Delivery to Nagoya"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ price.osaka_sales }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="osaka_sales" placeholder="Delivery to Nagoya"/>
        </td>
        <td v-if="!isSalesStaff">
            <span v-if="!checkIfEditEnabled">{{ price.kobe }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="kobe" placeholder="Delivery to Kobe"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ price.kobe_sales }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="kobe_sales" placeholder="Delivery to Kobe"/>
        </td>
        <td v-if="!isSalesStaff">
            <span v-if="!checkIfEditEnabled">{{ price.hakata }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="hakata" placeholder="Delivery to Hakata"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ price.hakata_sales }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="hakata_sales" placeholder="Delivery to Hakata"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled && companies[price.company]">{{ companies[price.company].name }}</span>
            <select v-if="checkIfEditEnabled" v-model="company" @change="changeCompany($event)" class="select">
                <option v-for="(company, index) in companies" :value="index">{{ company.name }}</option>
            </select>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ price.comment }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="comment" placeholder="Comment"/>
        </td>
    </tr>
</template>

<script>
    export default {
        props: ['price'],
        methods: {
            editPrice(price){
                this.$store.dispatch('setSelectedInlandPricePlan', price)
            },
            updatePrice() {
                this.$store.dispatch('updateInlandPrice')
                this.$store.dispatch('fetchAllInlandPrices')
            },
            changeCompany(event) {
                let id = event.target.value
                this.auction = this.companies[id].auction
                this.yokohama = this.companies[id].yokohama
                this.yokohama_sales = this.companies[id].yokohama_sales
                this.nagoya = this.companies[id].nagoya
                this.nagoya_sales = this.companies[id].nagoya_sales
                this.kobe = this.companies[id].kobe
                this.kobe_sales = this.companies[id].kobe_sales
                this.hakata = this.companies[id].hakata
                this.hakata_sales = this.companies[id].hakata_sales
            }
        },
        computed: {
            checkIfEditEnabled() {
                return this.$store.getters.getSelectedInlandPrice.id === this.price.id
            },
            lot_start: {
                get() {
                    return this.$store.getters.getSelectedInlandPrice.lot_start
                },
                set(value) {
                    this.$store.dispatch('setInlandPriceFieldValue', {field: 'lot_start', value: value})
                }
            },
            lot_end: {
                get() {
                    return this.$store.getters.getSelectedInlandPrice.lot_end
                },
                set(value) {
                    this.$store.dispatch('setInlandPriceFieldValue', {field: 'lot_end', value: value})
                }
            },
            auction: {
                get() {
                    return this.$store.getters.getSelectedInlandPrice.auction
                },
                set(value) {
                    this.$store.dispatch('setInlandPriceFieldValue', {field: 'auction', value: value})
                }
            },
            yokohama: {
                get() {
                    return this.$store.getters.getSelectedInlandPrice.yokohama
                },
                set(value) {
                    this.$store.dispatch('setInlandPriceFieldValue', {field: 'yokohama', value: value})
                }
            },
            yokohama_sales: {
                get() {
                    return this.$store.getters.getSelectedInlandPrice.yokohama_sales
                },
                set(value) {
                    this.$store.dispatch('setInlandPriceFieldValue', {field: 'yokohama_sales', value: value})
                }
            },
            nagoya: {
                get() {
                    return this.$store.getters.getSelectedInlandPrice.nagoya
                },
                set(value) {
                    this.$store.dispatch('setInlandPriceFieldValue', {field: 'nagoya', value: value})
                }
            },
            nagoya_sales: {
                get() {
                    return this.$store.getters.getSelectedInlandPrice.nagoya_sales
                },
                set(value) {
                    this.$store.dispatch('setInlandPriceFieldValue', {field: 'nagoya_sales', value: value})
                }
            },
            osaka: {
                get() {
                    return this.$store.getters.getSelectedInlandPrice.osaka
                },
                set(value) {
                    this.$store.dispatch('setInlandPriceFieldValue', {field: 'osaka', value: value})
                }
            },
            osaka_sales: {
                get() {
                    return this.$store.getters.getSelectedInlandPrice.osaka_sales
                },
                set(value) {
                    this.$store.dispatch('setInlandPriceFieldValue', {field: 'osaka_sales', value: value})
                }
            },
            kobe: {
                get() {
                    return this.$store.getters.getSelectedInlandPrice.kobe
                },
                set(value) {
                    this.$store.dispatch('setInlandPriceFieldValue', {field: 'kobe', value: value})
                }
            },
            kobe_sales: {
                get() {
                    return this.$store.getters.getSelectedInlandPrice.kobe_sales
                },
                set(value) {
                    this.$store.dispatch('setInlandPriceFieldValue', {field: 'kobe_sales', value: value})
                }
            },
            hakata: {
                get() {
                    return this.$store.getters.getSelectedInlandPrice.hakata
                },
                set(value) {
                    this.$store.dispatch('setInlandPriceFieldValue', {field: 'hakata', value: value})
                }
            },
            hakata_sales: {
                get() {
                    return this.$store.getters.getSelectedInlandPrice.hakata_sales
                },
                set(value) {
                    this.$store.dispatch('setInlandPriceFieldValue', {field: 'hakata_sales', value: value})
                }
            },
            company: {
                get() {
                    return this.$store.getters.getSelectedInlandPrice.company
                },
                set(value) {
                    this.$store.dispatch('setInlandPriceFieldValue', {field: 'company', value: value})
                }
            },
            comment: {
                get() {
                    return this.$store.getters.getSelectedInlandPrice.comment
                },
                set(value) {
                    this.$store.dispatch('setInlandPriceFieldValue', {field: 'comment', value: value})
                }
            },
            companies () {
                return this.$store.getters.getInlandCompanies
            },
            isSalesStaff() {
                if (this.$store.getters.getUserRole === 'Sales Staff') {
                    return true
                }
            }
        }
    }
</script>

<style scoped>
    td {
        font-size: 10px;
        font-weight: bold;
        background-color: whitesmoke;
    }
    .is-responsive-table td {
        font-size: 10px;
    }
    .image {
        max-height: 32px;
        height: 32px;
        padding-left: 2px;
    }
    .is-automatic {
        background-color: rgba(0, 255, 255, 0.25);
    }
    .is-real {
        background-color: rgba(255, 255, 0, 0.27);
    }
    .is-win {

    }
    .is-canceled {

    }
    .nowrap {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .is-responsive-table table {
        width: 100%;
    }
    .is-responsive-table th {
        font-size: small;
    }
    .long {
        min-width: 75px;
    }
    .link {
        border-bottom: 1px solid blue;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/InlandPrices/InlandPriceTableRow.vue